import styled from "styled-components";

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const ModalContent = styled.div`
  display: flex;
  height: 85%;
  width: 70%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  padding: var(--sp-20);
  border-radius: 12px;
  margin: auto;
`;
export const Logo = styled.img`
  position: relative;
  bottom: 40%;
  width: calc(var(--u) * 100);
  height: calc(var(--u) * 100);
`;
export const CloseButton = styled.button`
  position: absolute;
  top: calc(var(--u) * 10);
  right: calc(var(--u) * 10);
  background: none;
  border: none;
  font-size: calc(var(--u) * 50);
  color: #ccc;
  cursor: pointer;
`;
export const SectionNavigation = styled.div`
  position: absolute;
  top: 25%;
  left: 0;
  margin-left: 17%;
`;
export const SectionButton = styled.button<{
  selected: boolean;
  color: string;
}>`
  color: ${(props) => (props.selected ? props.color : "#ccc")};
  cursor: pointer;
  font-weight: bold;
  background-color: transparent;
  border: none;
  font-size: var(--fs-xl);

  &:not(:disabled):hover {
    color: ${(props) => props.color};
  }
`;
export const MainModalPeriodoContent = styled.div`
  position: absolute;
  top: 30%;
  width: 65%;
  height: 60%;
  overflow-y: auto;
  font-size: var(--fs-xl);
  color: #303030;
  background-color: #bbcaff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: top;
  padding: var(--sp-20);
  z-index: 1;
`;
export const MainModalPeriodLogo = styled.img`
  bottom: 10%;
  right: 23%;
  position: fixed;
  width: calc(var(--u) * 300);
  height: calc(var(--u) * 300);
`;

interface PeriodActionButtonProps {
  type: "open" | "close";
}

export const PeriodActionButton = styled.button<PeriodActionButtonProps>`
  position: relative;
  align-self: center;
  background-color: ${(props) => (props.type === "open" ? "#3cb152" : "red")};
  color: white;
  border: none;
  border-radius: 12px;
  padding: var(--sp-10);
  font-size: var(--fs-xl);
  cursor: pointer;
`;
export const FieldCashContainer = styled.div`
  position: relative;
  align-self: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  padding: var(--sp-10);
`;
export const NumberCashInput = styled.div<{ color: string }>`
  font-size: var(--fs-xl);
  position: relative;
  border: 1.5px solid ${(props) => props.color};
  border-radius: 6px;
  input {
    width: 100%;
    font-size: var(--fs-xl);
    padding: var(--sp-4) var(--sp-2) var(--sp-2) var(--sp-4);
    border: 1.5px solid #bbbbbb;
    border-radius: 5px;
    outline: unset;
    transition: outline 0.2s ease;
  }

  input:focus {
    box-shadow: 0 0 0 1px #e8e8e8, 0 0 0 3px ${(props) => props.color};
  }

  label {
    transition: all 0.1s ease-in-out;
    color: #2c2c54;
    position: absolute;
    top: 50%;
    left: calc(var(--u) * 10);
    transform: translateY(-50%);
    pointer-events: none;
    background: white;
    padding: 0 var(--sp-5);
    border-radius: 5px;
  }

  input:focus ~ label,
  input:not(:placeholder-shown) ~ label {
    top: calc(var(--u) * 10);
    left: 0px;
    transform: scale(0.85) translateY(-120%);
    background: ${(props) => props.color};
    color: white;
  }
`;
export const UnitCash = styled.span<{ color: string }>`
  position: relative;
  font-size: var(--fs-xl);
  opacity: 0.8;
  color: ${(props) => props.color};
  font-weight: bold;
  right: 20%;
`;

export const MainModalEmployeesContent = styled.div`
  position: absolute;
  top: 30%;
  width: 65%;
  height: 60%;
  overflow-y: auto;
  background-color: #bbcaff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  padding: var(--sp-20);
`;
export const MainModalEmployeesLogo = styled.img`
  bottom: 7%;
  right: 20%;
  position: fixed;
  width: calc(var(--u) * 500);
  height: calc(var(--u) * 500);
`;
export const MainModalSettingsContent = styled.div`
  position: absolute;
  top: 30%;
  width: 65%;
  height: 60%;
  overflow-y: auto;
  background-color: #a2afdfba;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  padding: var(--sp-10) var(--sp-10) var(--sp-10) var(--sp-10);
`;
export const MainModalSettingsLogo = styled.img`
  bottom: 12%;
  right: 23.5%;
  position: fixed;
  width: calc(var(--u) * 400);
  height: calc(var(--u) * 400);
  opacity: 0.6;
  z-index: 0;
`;
export const CaixaContainer = styled.div<{ color: string }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  z-index: 1;
  margin-bottom: var(--sp-10);
  background-color: ${(props) => props.color + 30};
  border-radius: 12px;
  padding: var(--sp-10);
`;
export const StatusIndicator = styled.div<{ status: string }>`
  position: absolute;
  top: 10%; /* Ajuste a posição vertical conforme necessário */
  left: 95%; /* Ajuste a posição horizontal conforme necessário */
  width: calc(var(--u) * 20);
  height: calc(var(--u) * 20);
  border-radius: 50%;
  border: 1px solid black;
  background-color: ${(props) => (props.status === "Aberto" ? "green" : "red")};
  color: black;
  display: flex;
`;
export const StatusIndicatorText = styled.p`
  position: absolute;
  top: 10%; /* Ajuste a posição vertical conforme necessário */
  left: 78%; /* Ajuste a posição horizontal conforme necessário */
  font-size: var(--fs-base);
  color: black;
  display: flex;
  font-weight: bold;
`;
export const Caixa = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: var(--sp-10);
`;
export const CaixaImage = styled.img<{ selected: boolean; color: string }>`
  border-color: ${(props) => (props.selected ? props.color : "#00000090")};
  border-width: 2px;
  border-style: solid;
  width: calc(var(--u) * 70);
  height: calc(var(--u) * 70);
  border-radius: 50%;
  cursor: pointer;
`;
export const CaixaIcon = styled.div<{ selected: boolean; color: string }>`
  background-color: ${(props) => (props.selected ? props.color : "#00000090")};
  border-color: ${(props) => (props.selected ? props.color : "#00000090")};
  border-width: 2px;
  border-style: solid;
  font-family: "Material Icons";
  color: white;
  font-weight: bold;
  font-size: calc(var(--u) * 50);
  padding: calc(var(--u) * 7);
  width: calc(var(--u) * 70);
  height: calc(var(--u) * 70);
  border-radius: 50%;
  cursor: pointer;
  &:hover {
    background-color: ${(props) =>
    props.selected ? props.color : "#00000090"};
  }
`;
export const CaixaName = styled.p<{ selected: boolean; color: string }>`
  background-color: ${(props) => (props.selected ? props.color : "#00000090")};
  font-size: var(--fs-base);
  color: white;
  font-weight: bold;
  border-radius: 12px;
  padding: var(--sp-5);
  cursor: pointer;
  &:hover {
    background-color: ${(props) =>
    props.selected ? props.color : "#00000090"};
  }
`;
export const ConfigContainer = styled.div<{ color: string }>`
  padding: var(--sp-10);
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 1;
  background-color: ${(props) => props.color + 30};
  border-radius: 12px;
  margin-bottom: var(--sp-10);
`;
export const CustomizeContainer = styled.div<{ color: string }>`
  padding: var(--sp-10);
  display: flex;
  flex-direction: column;
  width: 100%;
  z-index: 1;
  background-color: ${(props) => props.color + 30};
  border-radius: 12px;
  margin-bottom: var(--sp-10);
`;
export const SelectedPDVInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  z-index: 1;
`;
export const ContainerTitle = styled.h3`
  align-self: flex-start;
  font-weight: bold;
  font-size: var(--fs-lg);
  z-index: 1;
`;
export const RowContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-items: center;
  padding: var(--sp-10);
`;
export const FieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  margin-bottom: var(--sp-10);
`;

export const FieldLabel = styled.label`
  margin-top: var(--sp-5);
  margin-right: var(--sp-10);
  font-size: var(--fs-base);
`;

export const Separator = styled.div<{ color: string }>`
  position: relative;
  right: calc(var(--u) * 9);
  font-size: var(--fs-lg);
  color: ${(props) => props.color};
`;

export const CirclePreview = styled.div<{ color: string }>`
  input[type="color"] {
    position: relative;
    width: calc(var(--u) * 20);
    height: calc(var(--u) * 20);
    border-radius: 50%;
    border: 1.5px solid #7e8489;
    background-color: ${(props) => props.color};
    padding: var(--sp-10);
    cursor: pointer;
  }
`;
export const TextInput = styled.div<{ color: string }>`
  width: calc(var(--u) * 300);
  font-size: var(--fs-base);
  position: relative;
  border: 1.5px solid ${(props) => props.color};
  border-radius: 6px;
  margin-right: var(--sp-10);
  input {
    width: 100%;
    font-size: var(--fs-base);
    padding: var(--sp-4) var(--sp-2) var(--sp-2) var(--sp-4);
    border: 1.5px solid #bbbbbb;
    border-radius: 5px;
    outline: unset;
    transition: outline 0.2s ease;
  }

  input:focus {
    box-shadow: 0 0 0 1px #e8e8e8, 0 0 0 3px ${(props) => props.color};
  }

  label {
    padding: 0 var(--sp-5);
    transition: all 0.1s ease-in-out;
    position: absolute;
    top: 50%;
    left: calc(var(--u) * 10);
    transform: translateY(-50%);
    pointer-events: none;
    background: #ffffff;
    border-radius: 5px;
  }

  input:focus ~ label,
  input:not(:placeholder-shown) ~ label {
    top: calc(var(--u) * 10);
    left: 0px;
    transform: scale(0.85) translateY(-120%);
    background: ${(props) => props.color};
    color: white;
  }
`;
export const NumberInput = styled.div<{ color: string }>`
  width: calc(var(--u) * 150);
  font-size: var(--fs-base);
  position: relative;
  border: 1.5px solid ${(props) => props.color};
  border-radius: 6px;
  input {
    width: 100%;
    font-size: var(--fs-base);
    padding: var(--sp-4) var(--sp-2) var(--sp-2) var(--sp-4);
    border: 1.5px solid #bbbbbb;
    border-radius: 5px;
    outline: unset;
    transition: outline 0.2s ease;
  }

  input:focus {
    box-shadow: 0 0 0 1px #e8e8e8, 0 0 0 3px ${(props) => props.color};
  }

  label {
    transition: all 0.1s ease-in-out;
    color: #2c2c54;
    position: absolute;
    top: 50%;
    left: calc(var(--u) * 10);
    transform: translateY(-50%);
    pointer-events: none;
    background: white;
    padding: 0 var(--sp-5);
    border-radius: 5px;
  }

  input:focus ~ label,
  input:not(:placeholder-shown) ~ label {
    top: calc(var(--u) * 10);
    left: 0px;
    transform: scale(0.85) translateY(-120%);
    background: ${(props) => props.color};
    color: white;
  }
`;
export const Unit = styled.span<{ color: string }>`
  position: relative;
  font-size: var(--fs-base);
  opacity: 0.8;
  color: ${(props) => props.color};
  font-weight: bold;
  right: 35%;
`;
export const ProportionSlider = styled.input<{
  color: string;
  value?: number;
  max?: number;
}>`
  -webkit-appearance: none;
  width: calc(var(--u) * 100);
  height: calc(var(--u) * 6);
  border-radius: 5px;
  outline: none;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: calc(var(--u) * 16);
    height: calc(var(--u) * 16);
    border-radius: 50%;
    background: white;
    cursor: pointer;
    box-shadow: 0px 0px 5px rgba(66, 97, 255, 0.5);
    position: relative;
    top: calc(var(--u) * -5);
    z-index: 2;
  }

  &::-moz-range-thumb {
    width: calc(var(--u) * 16);
    height: calc(var(--u) * 16);
    border-radius: 50%;
    background: white;
    cursor: pointer;
    box-shadow: 0px 0px 5px rgba(66, 97, 255, 0.5);
    position: relative;
    z-index: 2;
  }

  &::-ms-thumb {
    width: calc(var(--u) * 16);
    height: calc(var(--u) * 16);
    border-radius: 50%;
    background: white;
    cursor: pointer;
    box-shadow: 0px 0px 5px rgba(66, 97, 255, 0.5);
    position: relative;
    z-index: 2;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: calc(var(--u) * 6);
    background: ${(props) => {
    const value = props.value ?? 0;
    const max = props.max ?? 1;

    return `linear-gradient(to right, ${props.color}, ${(value * 100) / max
      }%, white ${(value * 100) / max}%, white)`;
  }};
    border-radius: 5px;
    border: none;
    position: relative;
    z-index: 1;
  }
`;

export const FileInput = styled.input`
  opacity: 0;
  position: relative;
  top: calc(var(--u) * -25);
  font-size: calc(var(--u) * 25);
  z-index: 1;
  cursor: pointer;
  width: calc(var(--u) * 180);
`;
export const FileInputContainer = styled.div`
  background-color: #ffffff;
  border-radius: 6px;
  margin-left: var(--sp-10);
  margin-right: var(--sp-10);
  width: calc(var(--u) * 160);
  height: calc(var(--u) * 35);
  cursor: pointer;
`;
export const FileInputLabel = styled.label<{ color: string }>`
  position: relative;
  font-weight: bold;
  top: calc(var(--u) * 5);
  padding: var(--sp-5);
  border-radius: 50%;
  color: ${(props) => props.color};
  font-size: var(--fs-base);
`;
export const StyledIcon = styled.div<{ color: string }>`
  position: relative;
  bottom: calc(var(--u) * 60);
  left: 85%;
  font-size: calc(var(--u) * 25);
  color: ${(props) => props.color};
  font-family: "Material Icons";
  z-index: 0;
`;
export const SwitchLabel = styled.label`
  font-size: var(--fs-base);
  position: relative;
  width: 3.5em;
  height: 2em;
`;

export const SwitchInput = styled.input`
  opacity: 1;
  width: 0;
  height: 0;
  &.checked {
    transform: translateX(1.4em);
    background-color: #fff;
  }
`;

export const Slider = styled.span<{ color: string }>`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  border: 1px solid ${(props) => props.color};
  transition: 0.4s;
  border-radius: 30px;
  &.checked {
    background-color: ${(props) => props.color};
  }
`;

export const SliderThumb = styled.span`
  position: absolute;
  height: 1.4em;
  width: 1.4em;
  border-radius: 20px;
  left: 0.27em;
  bottom: 0.25em;
  background-color: #adb5bd;
  transition: 0.4s;
  &.checked {
    background-color: #ffffff;
    transform: translateX(1.4em);
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: var(--sp-10);
`;

export const DropdownInput = styled.div<{ color: string }>`
  width: calc(var(--u) * 130);
  font-size: var(--fs-base);
  position: relative;
  border: 1px solid ${(props) => props.color};
  border-radius: 6px;
  select {
    width: 100%;
    font-size: var(--fs-base);
    padding: var(--sp-4) var(--sp-2) var(--sp-2) var(--sp-4);
    border: 1px solid #bbbbbb;
    border-radius: 5px;
    outline: unset;
    transition: outline 0.2s ease;

    /* Estilos para o select */
  }

  select:focus {
    box-shadow: 0 0 0 1px #e8e8e8, 0 0 0 3px ${(props) => props.color};
  }

  label {
    padding: 0 var(--sp-5);
    transition: all 0.1s ease-in-out;
    position: absolute;
    top: 50%;
    left: calc(var(--u) * 10);
    transform: translateY(-50%);
    pointer-events: none;
    background: #ffffff;
    border-radius: 5px;

    /* Estilos para o label (igual aos campos de texto e número) */
  }

  select:focus ~ label,
  select:not(:placeholder-shown) ~ label {
    top: calc(var(--u) * 10);
    left: 0px;
    transform: scale(0.85) translateY(-120%);
    background: ${(props) => props.color};
    color: white;
  }
`;
export const customStyles = {
  overlay: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#00000170",
    with: "100%",
    height: "100%",
  },
  content: {
    border: "none",
    background: "none",
    padding: "0",
  },
};
export const TableContainer = styled.div`
  display: flex;
  margin-bottom: var(--sp-20);
  gap: var(--sp-20);
  width: 100%;
  align-items: flex-start;
`;

export const TableWrapper = styled.div`
  width: 48%;
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #ffffff;
  overflow: hidden;
  max-height: calc(var(--u) * 500); /* Limita a altura máxima */
`;

export const ExpandableTableWrapper = styled(TableWrapper)`
  overflow-y: auto; /* Adiciona rolagem apenas para a tabela da esquerda */
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  z-index: 1;
`;

export const TableHeader = styled.th`
  padding: var(--sp-10);
  text-align: left;
  background-color: #e8f1ff;
  color: #333;
  font-weight: bold;
  font-size: calc(var(--u) * 15);
  border-bottom: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
    background-color: #ffffff;

  &:nth-child(even) {
    background-color: #f9f9f9;
  }
  &:hover {
    background-color: #e6f2ff;
  }
`;

export const TableCell = styled.td`
  padding: var(--sp-10);
  border-bottom: 1px solid #e0e0e0;
  font-size: var(--fs-md);
  color: #555;
`;

export const TableFooterCell = styled.td`
  padding: var(--sp-12);
  font-size: calc(var(--u) * 15);
  text-align: right;
  font-weight: bold;
  background-color: #f2f2f2;
`;
export const TableRowRemoveButton = styled.button`
margin-left: 50%;
background-color: #ff4d4d;
color: white;
border: none;
border-radius: 5px;
cursor: pointer;
transition: background-color 0.2s ease;
&:hover {
  background-color: #ff6666;
}

`;


/* Estilos para informações do período */
export const PeriodInfoContainer = styled.div`
  background-color: #f5f9ff;
  border-radius: 12px;
  padding: var(--sp-20);
  margin-bottom: var(--sp-20);
  color: #333;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

export const PeriodInfoHeader = styled.h3`
  font-size: var(--fs-lg);
  font-weight: bold;
  color: #007bff;
  margin-bottom: var(--sp-10);
`;

export const PeriodInfoText = styled.p`
  font-size: var(--fs-base);
  margin: var(--sp-8) 0;
  color: #666;
  display: flex;
  justify-content: space-between;
  & > span {
    font-weight: bold;
  }
`;

export const PeriodStatus = styled.span<{ status: string }>`
  font-weight: bold;
  color: ${(props) => (props.status === "Aberto" ? "#28a745" : "#dc3545")};
`;